/**
 * Global-child - assets/js.
 */

/**
 * Vanilla JS.
 */

/**
 * Details animation bug fix.
 */
const detailsDefault = document.querySelector( 'details.ft-default' );
const summaryDefault = document.querySelector( 'summary.ft-default' );
summaryDefault.addEventListener( 'click', function( e ) {
	if ( detailsDefault.hasAttribute( 'open' ) ) {
		e.preventDefault(); //デフォルトの動きをキャンセル
		detailsDefault.classList.add( 'closing' );

		//openとclosingを0.4秒で削除
		setTimeout( () => {
			detailsDefault.removeAttribute( 'open' );
			detailsDefault.classList.remove( 'closing' );
		}, 400 );
	}
});
const detailsFixed = document.querySelector( 'details.ft-fixed' );
const summaryFixed = document.querySelector( 'summary.ft-fixed' );
summaryFixed.addEventListener( 'click', function( e ) {
	if ( detailsFixed.hasAttribute( 'open' ) ) {
		e.preventDefault(); //デフォルトの動きをキャンセル
		detailsFixed.classList.add( 'closing' );

		//openとclosingを0.4秒で削除
		setTimeout( () => {
			detailsFixed.removeAttribute( 'open' );
			detailsFixed.classList.remove( 'closing' );
		}, 400 );
	}
});

/**
 * Swiper.
 */

// 関連商品
/*let swiperOptionSlide = {
	loop: true,
	slidesPerView: 2,
	spaceBetween: 8,
	autoplay: {
		delay: 4000,
		disableOnInteraction: false,
	},
	speed: 3000,
	pagination: {
		el: '.swiper-pagination',
		clickable: true,
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},

	breakpoints: {
		768: {
			slidesPerView: 4,
			spaceBetween: 24,
		},
	},
};
let sliderRelated = new Swiper( '.swiper-related', swiperOptionSlide );*/

/**
 * Sakura.
 */
//if ( ! navigator.userAgentData.mobile ) {
if ( ! navigator.userAgent.match( /(iPhone|iPad|iPod|Android)/i ) ) {
	particlesJS( 'particles-js', {
		particles: {
			number: {
				value: 24, //この数値を変更すると桜の数が増減できる
				density: {
					enable: true,
					value_area: 1121.6780303333778,
				},
			},
			color: {
				value: '#fff',
			},
			shape: {
				type: 'image', //形状は画像を指定
				stroke: {
					width: 0,
				},
				image: {
					src: 'https://trial.grace-create.com/wp-01/wp-content/themes/fujikihonten--child-of-nucleus/assets/images/common/petal.webp',
					width: 120,
					height: 120,
				},
			},
			opacity: {
				value: 0.06409588744762158,
				random: true,
				anim: {
					enable: false,
					speed: 1,
					opacity_min: 0.1,
					sync: false,
				},
			},
			size: {
				value: 8.011985930952697,
				random: true, //サイズをランダムに
				anim: {
					enable: false,
					speed: 4,
					size_min: 0.1,
					sync: false,
				},
			},
			line_linked: {
				enable: false,
			},
			move: {
				enable: true,
				speed: 2, //この数値を小さくするとゆっくりな動きになる
				direction: 'bottom-left', //右下に向かって落ちる
				random: false, //動きはランダムにしない
				straight: false, //動きをとどめない
				out_mode: 'out', //画面の外に出るように描写
				bounce: false, //跳ね返りなし
				attract: {
					enable: false,
					rotateX: 281.9177489524316,
					rotateY: 127.670995809726,
				},
			},
		},
		interactivity: {
			detect_on: 'canvas',
			events: {
				onhover: {
					enable: false,
				},
				onclick: {
					enable: false,
				},
				resize: true,
			},
		},
		retina_detect: false,
	});
}

/**
 * Parallax.
 */
const rellax = new Rellax( '.parallax', {
	speed: 8,
	center: false,
	wrapper: null,
	round: true,
	vertical: true,
	horizontal: false,
});

/**
 * Header nav display.
 */
const isDisplay = function() {
	const hPrimary = document.querySelectorAll( '.p-header__primary' );
	for ( let i = 0; i < hPrimary.length; i++ ) {
		hPrimary[i].classList.add( 'is-display' );
	}
};
setTimeout( isDisplay, 800 );

/**
 * Header nav display scroll
 */
const HNDSArea = document.querySelector( '#header' );
const HNDSBTN = document.getElementById( 'fixed-header' );

const HNDSCallback = ( entries ) => {
	if ( entries[0].isIntersecting ) {
		HNDSBTN.style.opacity = '0';
		HNDSBTN.style.pointerEvents = 'none';
		HNDSBTN.classList.remove( 'fixed-on' );
	} else {
		HNDSBTN.style.opacity = '1';
		HNDSBTN.style.pointerEvents = 'auto';
		HNDSBTN.classList.add( 'fixed-on' );
	}
};

const HNDSObserver = new IntersectionObserver( HNDSCallback );
HNDSObserver.observe( HNDSArea );

/**
 * LOAD MORE.
 */
const infScroll = new InfiniteScroll( '.load-more', {
	append: '.load-more-append',
	path: '.next',
	hideNav: '.pagination',
	button: '#more-button',
	scrollThreshold: false,
	status: '.scroller-status',
	history: 'push',
});

const infiniteItem = document.querySelectorAll( '.more-load-append' );

infScroll.on( 'append', function( response, path, items ) {
	for ( let i = 0; i < items.length; i++ ) {
		reloadSrcsetImgs( infiniteItem[i]);
	}
});

function reloadSrcsetImgs( infiniteItem ) {
	let imgs = infiniteItem.querySelectorAll( 'img[srcset]' );
	for ( let i = 0; i < imgs.length; i++ ) {
		let img = imgs[i];
		img.outerHTML = img.outerHTML;
	}
}

/**
 * Wave.
 */
const waveArea = document.querySelector( '#header' );
const waveContent = document.getElementById( 'wave' );

const waveCallback = ( entries ) => {
	if ( entries[0].isIntersecting ) {
		waveContent.style.opacity = '0';
		waveContent.style.pointerEvents = 'none';
		waveContent.classList.add( 'display-off' );
	} else {
		waveContent.style.opacity = '1';
		waveContent.style.pointerEvents = 'auto';
		waveContent.classList.add( 'display-on' );
	}
};

const waveObserver = new IntersectionObserver( waveCallback );
waveObserver.observe( waveArea );

( function() {
	let unit = 100,
		canvas,
		context,
		height,
		width,
		xAxis,
		yAxis;

	/**
	 * Init function.
	 *
	 * Initialize variables and begin the animation.
	 */
	function init() {
		canvas = document.getElementById( 'wave-canvas' );

		//Canvasのwidthをウィンドウの幅に合わせる
		//Canvasのheightとwidthはcssで
		//canvas.width = document.documentElement.clientWidth;
		//canvas.height = 40;

		context = canvas.getContext( '2d' );

		height = canvas.height;
		width = canvas.width;

		xAxis = Math.floor( height / 2 );
		yAxis = 0;

		drawAnimation();
	}

	/**
	 * Draw animation function.
	 *
	 * This function draws one frame of the animation, waits 20ms, and then calls
	 * itself again.
	 */
	function drawAnimation() {

		// キャンバスの描画をクリア
		context.clearRect( 0, 0, width, height );

		//波を描画
		drawWave( 'rgba( 255, 255, 255, 0.96 )', 1, 3, 0 );

		// Update the time and draw again
		drawAnimation.seconds = drawAnimation.seconds + 0.004; //スピードを調整
		drawAnimation.t = drawAnimation.seconds * Math.PI;
		setTimeout( drawAnimation, 32 );
	}
	drawAnimation.seconds = 0;
	drawAnimation.t = 0;

	/**
	 * 波を描画
	 * drawWave(色, 不透明度, 波の幅のzoom, 波の開始位置の遅れ)
	 */
	function drawWave( color, alpha, zoom, delay ) {
		context.fillStyle = color;
		context.globalAlpha = alpha;

		context.beginPath(); //パスの開始
		drawSine( drawAnimation.t / 0.5, zoom, delay );
		context.lineTo( width + 10, height ); //パスをCanvasの右下へ
		context.lineTo( 0, height ); //パスをCanvasの左下へ
		context.closePath(); //パスを閉じる
		context.fill(); //塗りつぶす
	}

	/**
	 * Function to draw sine
	 *
	 * The sine curve is drawn in 10px segments starting at the origin.
	 * drawSine(時間, 波の幅のzoom, 波の開始位置の遅れ)
	 */
	function drawSine( t, zoom, delay ) {

		// Set the initial x and y, starting at 0,0 and translating to the origin on
		// the canvas.
		let x = t; //時間を横の位置とする
		let y = Math.sin( x ) / zoom;
		context.moveTo( yAxis, unit * y + xAxis ); //スタート位置にパスを置く

		// Loop to draw segments (横幅の分、波を描画)
		for ( i = yAxis; i <= width + 10; i += 10 ) {
			x = t + ( -yAxis + i ) / unit / zoom;
			y = Math.sin( x - delay ) / 8; //波の高さを調整
			context.lineTo( i, unit * y + xAxis );
		}
	}

	init();
}() );

/**
 * スマホメニューのページ内リンク対応
 */
document.addEventListener( 'DOMContentLoaded', function() {
	const fixedHtml = document.querySelectorAll( 'html' );
	const NavText = document.querySelectorAll( '.inner-link a' );
	const Hamburger = document.getElementById( 'btn-hamburger' );
	const HamburgerFH = document.getElementById( 'btn-hamburger-fh' );
	for ( let i = 0; i < NavText.length; i++ ) {
		NavText[i].addEventListener( 'click', function() {
			Hamburger.checked = false;
			HamburgerFH.checked = false;
			for ( let i = 0; i < fixedHtml.length; i++ ) {
				fixedHtml[i].style.height = 'auto';
				fixedHtml[i].style.overflow = 'visible';
			}
		});
	}
});

/**
 * woocommerce_checkout_fieldsの<form>にyubinbango用のクラスを付ける
 */

//Billing
const billingCol = document.querySelectorAll( '#customer_details .col-1' );
const billingPostCode = document.querySelectorAll(
	'#billing_postcode_field .input-text'
);
const billingState = document.querySelectorAll(
	'#billing_state_field .state_select'
);
const billingCity = document.querySelectorAll(
	'#billing_city_field .input-text'
);
const billingAddress01 = document.querySelectorAll(
	'#billing_address_1_field .input-text'
);
const billingAddress02 = document.querySelectorAll(
	'#billing_address_2_field .input-text'
);
for ( let i = 0; i < billingCol.length; i++ ) {
	billingCol[i].setAttribute(
		'class',
		'checkout woocommerce-checkout col-1 h-adr'
	);
}
for ( let i = 0; i < billingPostCode.length; i++ ) {
	billingPostCode[i].setAttribute( 'class', 'input-text p-postal-code' );
}
for ( let i = 0; i < billingState.length; i++ ) {
	billingState[i].setAttribute(
		'class',
		'state_select select2-hidden-accessible p-region p-region-id'
	);
}
for ( let i = 0; i < billingCity.length; i++ ) {
	billingCity[i].setAttribute( 'class', 'input-text p-locality' );
}
for ( let i = 0; i < billingAddress01.length; i++ ) {
	billingAddress01[i].setAttribute( 'class', 'input-text p-street-address' );
}
for ( let i = 0; i < billingAddress02.length; i++ ) {
	billingAddress02[i].setAttribute( 'class', 'input-text p-extended-address' );
}

//Shipping
const shippingCol = document.querySelectorAll( '#customer_details .col-2' );
const shippingPostCode = document.querySelectorAll(
	'#shipping_postcode_field .input-text'
);
const shippingState = document.querySelectorAll(
	'#shipping_state_field .state_select'
);
const shippingCity = document.querySelectorAll(
	'#shipping_city_field .input-text'
);
const shippingAddress01 = document.querySelectorAll(
	'#shipping_address_1_field .input-text'
);
const shippingAddress02 = document.querySelectorAll(
	'#shipping_address_2_field .input-text'
);
for ( let i = 0; i < shippingCol.length; i++ ) {
	shippingCol[i].setAttribute(
		'class',
		'checkout woocommerce-checkout col-2 h-adr'
	);
}
for ( let i = 0; i < shippingPostCode.length; i++ ) {
	shippingPostCode[i].setAttribute( 'class', 'input-text p-postal-code' );
}
for ( let i = 0; i < shippingState.length; i++ ) {
	shippingState[i].setAttribute(
		'class',
		'state_select select2-hidden-accessible p-region p-region-id'
	);
}
for ( let i = 0; i < shippingCity.length; i++ ) {
	shippingCity[i].setAttribute( 'class', 'input-text p-locality' );
}
for ( let i = 0; i < shippingAddress01.length; i++ ) {
	shippingAddress01[i].setAttribute( 'class', 'input-text p-street-address' );
}
for ( let i = 0; i < shippingAddress02.length; i++ ) {
	shippingAddress02[i].setAttribute( 'class', 'input-text p-extended-address' );
}

/**
 * jQuery.
 */
jQuery( document ).ready( function( $ ) {

	/**
	 * Glow animation text.
	 */
	$( window ).on( 'load', function() {
		let element = $( '.p-header__secondary-text p' );
		element.each( function() {
			let text = $( this ).text();
			let textbox = '';
			text.split( '' ).forEach( function( t, i ) {
				if ( ' ' !== t ) {
					if ( 4 > i ) {
						textbox +=
							'<span style="animation-delay:.' +
							i +
							's;">' +
							t +
							'</span>';
					} else {
						let n = i / 4;
						textbox +=
							'<span style="animation-delay:' +
							n +
							's;">' +
							t +
							'</span>';
					}
				} else {
					textbox += t;
				}
			});
			$( this ).html( textbox );
		});
	});
});
